const styles = {
  actionButton: {
    width: 100,
    fontSize: 12,
  },
  title: {
    lineHeight: 1.5,
    fontSize: { xs: 25, md: 28 },
  },
  footer: {
    justifyContent: "center",
    position: "sticky",
    zIndex: { xs: "2", md: "auto" },
    bottom: 0,
    width: "100%",
    p: { xs: 1, md: 2 },
  },
};
export default styles;
